import store from "../../../store";

class ConfigService {
  institutionId(): number | null {
    const id: number = store.getters["security/getSelectedInstitution"]();
    if (id) {
      return id;
    } else {
      return null;
    }
  }

  APIUrl(aSubPath: string): string {
    if (import.meta.env.VITE_VUE_APP_MOCKDATA === "true") {
      return "http://localhost/api/" + aSubPath;
    } else {
      return store.state.mainConfig.APP_API_URL + "/api/" + aSubPath;
    }
  }
}

export function ObjectFromEnvelope<T>(envelopedata: any): T {
  if (envelopedata.data === undefined) {
    throw new Error("Indeholder ikke data element i retur svaret");
  }
  return envelopedata.data as T;
}

export function ArrayFromEnvelope<T>(envelopedata: any): Array<keyof T> {
  if (envelopedata.data === undefined) {
    throw new Error("Indeholder ikke data element i retur svaret");
  }
  return [...envelopedata.data];
}
// export a singleton instance in the global namespace
export const configService: ConfigService = new ConfigService();
